export const storageNamespace = '@useStatePerist:';
export const cacheKey = '@useStatePersistCacheKey';
export const cacheKeyTTL = '@useStatePersistCacheKeyTTL';
